module.exports = __webpack_public_path__ + "img/joins.1a034521.png";